import React, { useEffect, useState } from "react";
import { Box, Badge, Flex, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchReferralsAction } from "../../../../state/actions/referralActions";
import ReusableTable from "components/Tables/ReusableTable";
import Skeleton from "react-loading-skeleton";

const ReferralManagement = () => {
  const dispatch = useDispatch();

  const { referral_users, loading, count } = useSelector(
    (state) => state.referralUsers
  );


  useEffect(() => {
    dispatch(fetchReferralsAction());
  }, [dispatch]);

  const tableData = referral_users || [];

  const tierColorScheme = {
    Bronze: "orange",
    Silver: "gray",
    Gold: "yellow",
    Platinum: "purple",
  };

  const columns = [
    {
      Header: "User",
      accessor: (row) => `${row.first_name} ${row.last_name}`,
    },
    {
      Header: "Phone",
      accessor: "phone_number",
    },
    {
      Header: "Referral Code",
      accessor: "referral_code",
    },
    {
      Header: "Points",
      accessor: "points",
    },
    {
      Header: "Tier",
      accessor: "tier",
      Cell: ({ value }) => (
        <Badge
          colorScheme={tierColorScheme[value] || "gray"}
          borderRadius="full"
          px={2}
        >
          {value}
        </Badge>
      ),
    },
    {
      Header: "Total Referred",
      accessor: "total_referred",
    },
    {
      Header: "Drivers",
      accessor: "driver_referred",
    },
    {
      Header: "Businesses",
      accessor: "business_referred",
    },
    {
      Header: "Individuals",
      accessor: "individual_referred",
    },
    {
      Header: "Joined",
      accessor: "created_at",
      Cell: ({ value }) => new Date(value).toLocaleDateString(),
    },
  ];

  return (
    <Box>
      <Box p={6}>
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize="md" fontWeight="bold">
            {loading ? (
              <Skeleton height="20px" width="120px" />
            ) : (
              `All Referrers: ${count ?? 0}`
            )}
          </Text>
        </Flex>
      </Box>

      <ReusableTable columnsData={columns} tableData={tableData} />

    </Box>
  );
};

export default ReferralManagement;